/**
 * FloatingWhatsApp — tombol chat melayang ke admin toko.
 *
 * Disembunyikan di /admin/*: itu halaman owner sendiri, dan tombol "hubungi
 * admin" di sana hanya menutupi tabel data tanpa guna.
 */

import { useLocation } from "react-router-dom";

/**
 * Nomor dalam format internasional tanpa "+" — itu yang diminta wa.me.
 * 0815-1101-2524 → 62 815 1101 2524.
 */
const WA_NUMBER = "6281511012524";

const GREETING = "Halo AG5R.STORE, saya mau tanya soal produk.";

export function FloatingWhatsApp() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  const href = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(GREETING)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat admin via WhatsApp"
      title="Chat admin via WhatsApp"
      /*
       * z-30 disengaja: di bawah header (z-40) dan modal (z-50) supaya tombol
       * ini tidak pernah menimpa dialog checkout atau menu akun.
       */
      className="fixed z-30 bottom-4 right-4 sm:bottom-6 sm:right-6
                 inline-flex items-center gap-2
                 rounded-full border border-border-strong bg-surface
                 pl-3.5 pr-4 py-3 shadow-lift
                 text-ink-primary hover:border-terminal hover:text-terminal
                 focus-visible:outline focus-visible:outline-2 focus-visible:outline-terminal"
    >
      <i className="fa-brands fa-whatsapp text-xl leading-none" aria-hidden />
      {/* Label disembunyikan di layar sempit: di 375px ia melebarkan tombol
          sampai menutupi konten. Ikon WhatsApp sendiri sudah dikenali. */}
      <span className="hidden sm:inline font-mono text-2xs tracking-widest uppercase">
        Chat Admin
      </span>
    </a>
  );
}
